<template>
  <v-app class="template-default">
    <loading/>
    <core-navigation-drawer>
      <div class="menu">
        <core-menu/>
      </div>
    </core-navigation-drawer>
    <v-app-bar app height="60" class="toolbar">
      <v-icon class="mobile_menu" @click="showAside()">mdi-menu</v-icon>
      <core-title/>
      <v-spacer/>
      <core-toolbar/>
    </v-app-bar>
    <notificacao id="notificao-sistema" @eventoNotificacao="eventoNotificacao"/>
    <v-main>
      <v-container fluid class="containerBody">
        <core-view/>
      </v-container>
      <core-footer/>
    </v-main>
  </v-app>
</template>

<script>
import {mutationTypes} from '@/core/constants'
import Loading from '@/views/components/Loading'
import Notificacao from '@/views/components/Notificacao'
import CoreView from '@/views/components/core/View.vue'
import CoreFooter from '@/views/components/core/Footer.vue'
import CoreTitle from '@/views/components/core/Title.vue'
import CoreToolbar from '@/views/components/core/Toolbar.vue'
import CoreMenu from '@/views/components/core/Menu.vue'
import CoreNavigationDrawer from '@/views/components/core/NavigationDrawer.vue'

export default {
    name: 'core-template-default',
    components: {
        CoreNavigationDrawer,
        CoreMenu, CoreToolbar, CoreTitle, CoreFooter, CoreView, Notificacao, Loading
    },
    methods: {
        showAside() {
            this.$store.commit(mutationTypes.DRAWER.SET_ASIDE_HIDE, true)
        },
        eventoNotificacao(evento) {
            if (!evento) return

            if (evento.nomeEvento === 'acessarFichaPaciente') {
                this.$router.push({name: 'PacienteFicha', params: {id: evento.pacienteId}})
            }
        }
    }
}
</script>

<style lang="stylus">
.template-default
  .aside-drawer
    .logo
      border-bottom 1px solid rgba(255, 255, 255, .1)
      height 120px

  .containerBody
    background-color #ee
    height 100%
    overflow hidden

  .toolbar
    box-shadow 0 2px 4px -1px rgba(0, 0, 0, .2)
    background-color white !important

  .mobile_menu
    display none

body
  background-color #eee

.application.theme--light
  background unset !important

.application--wrap
  min-height unset !important

html
  overflow-y auto

#notificao-sistema
  .v-snack__wrapper
    margin-top 45px

@media (max-width 720px)
  .template-default
    .mobile_menu
      margin-right 10px
      display unset !important
      top 1px
      position relative
      color var(--v-primary-base) !important

    .title__subtitle
      display none

    .no-mobile
      display none !important
</style>